<template>
    <div v-editable="blok" class="text-html-section" :style="styles">
        <div class="container mx-auto rich-text">
            <div v-html="blok.content"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ITextHtml } from '@nuxt-monorepo/ui/types/components/Text/TextHtml';

const { blok } = defineProps<{ blok: ITextHtml }>();
const styles = computed(() => {
    return `
        ${typeof blok.paddingTop === 'string' ? `padding-top: ${blok.paddingTop}rem;` : ''}
        ${typeof blok.paddingBottom === 'string' ? `padding-bottom: ${blok.paddingBottom}rem;` : ''}
        ${typeof blok.paddingLeft === 'string' ? `padding-left: ${blok.paddingLeft}rem;` : ''}
        ${typeof blok.paddingRight === 'string' ? `padding-right: ${blok.paddingRight}rem;` : ''}
        ${typeof blok.color?.color === 'string' ? `color: ${blok.color?.color};` : ''}
    `;
});
</script>

<style scoped lang="postcss">
.text-html-section {
    @apply px-4 py-8 xl:px-0;
}
</style>
